export const SOCIAL_CUES = true; // boughtSocialCues // true for all
export const MERCHANT_AREA = true; // true for Wowcher, Wowcher IE and 5pm
export const SHOW_MARKETING_CLAIM_DEFINITIONS = true; // false for wowcher ie and living social ie
export const TRUST_BOX = true; // false for wowcher ie, living social ie, and living social uk
export const SHOW_POPULAR_LOCATION_LIST = false; // false for wowcher ie and five pm
export const TEXT_LOWERCASE = false; // true for living social uk and ie
export const WISHLIST = false;
export const NEED_REPLACEMENT_BINARY_URLS = true; // only true for 5pm
export const BESTSELLER_CUE = true; // true for all
export const BOUGHT_COUNT_CUE = true; // true for all
export const GIFT_PACK = false; // true for Wowcher, Wowcher IE, LS and LS IE
export const SHOW_GIFTING_BUTTON = true;
export const EXPRESS_GIFT_PACK = true; // true for Wowcher, Wowcher IE and 5pm
export const RAF = false; // Refer A Friend true for Wowcher, Wowcher IE
export const CASHBACK = true; // true for Wowcher, Wowcher IE, LS and LS IE
export const TILES = false;
export const AUTO_ADDRESS_LOOKUP = true; // true for Wowcher, Wowcher IE and five-pm
export const EIR_POSTCODE = false; // true for IE sites
export const POSTCODE = false; // true for IE sites
export const APPEND_BLACKFRIDAY_LINKS = true; // true for wowcher and five pm
export const SHOW_CARROUSEL_ARROWS = true;
export const PAYPAL_CREDIT_LEGAL = true; // true for Wowcher, LS and 5pm
export const KLARNA_ENABLED = false;
export const GIFTING_BTN_OTHER_VARIANT = false;
export const ENABLE_BASKET_DEAL_PRODUCT_GIFTING_FULL = true; // true on wowcher and fivepm
export const IS_LIVINGSOCIAL_IRELAND = false;
export const SHOW_SECONDARY_BUTTON_REDDEM_FORM = true; // this is true for 5pm
export const SHOW_TERTIARY_BUTTON_REDDEM_FORM = false; // this is false for 5pm
export const PAYPAL_CREDIT_ENABLED = true;
export const MARKETING_CLAIMS_ENABLED = false; // this is true for IE sites
export const IS_PAYPAL_MESSAGING_ENABLED = false; // this is true for IE sites
export const RESERVATION_TIMER_ENABLED = true; // this is false on IE sites
export const FACEBOOK_LOGIN_ENABLED = false; // true for LS and LS IE
export const IS_PRIMARY_ACTION_BUTTON = false; // true for living social and ie
export const SHOW_DISCOUNT_CODES = false; // true for wowcher and wowcher ie
export const IS_FIND_PAGE_ENABLED = true;
export const SHOW_FOOTER_EXTRA_ITEMS = false;
export const HIDE_FOOTER_COL = false; // this is true for IE sites
export const ADD_FOOTER_LINKS = true; // this is only true for 5pm
export const COUNTDOWN_TIMER = false; // true for only IE sites
export const DEAL_SPLAT_VARIANT_TWO = false; // true for LS and LS IE
export const SHOW_NAV_POPOVER = false; // true for LS and LS IE
export const BRAND_APP_AVAILABLE = false; // true for wowcher and wowcher ie
export const ENABLE_GROUP_NAV = true; // true for all
export const ENABLE_NATIONAL_NAV = true; // true for all
export const SHOW_LOCALLINK_SUBNAV = false; // true all but 5pm
export const HAS_COUNTRY_PATH = true; // false all but 5pm
export const SHOW_RECCOMENDED_IN_CAROUSEL = true; // false for all IE
export const HAS_FIND_PAGE = true; // true for Wowcher and 5pm
export const HAS_CAREERS_LINK = false; // true for Wowcher UK only
export const HAS_APP_LINKS = false; // true for Wowcher and LS
export const HAS_GIFTCARD_PAGE = false; // true for Wowcher and LS, false for 5pm
export const BRAND_SWAP = false; // true for Wowcher
export const VIP_PAYWALL_LOGO = true; // true for Wowcher and 5pm
export const CLEARPAY_ENABLED = true; // true for Wowcher and 5pm
export const LIGHTBOX_MODAL_VARIANT_TWO = true;
export const HAS_NEARME_PAGES = false; // only Wowcher UK has
export const HAS_PRIVACY_POLICY_PAGE = true; // Wowcher + LS have static pages, true for others
export const IS_G_SHOP_OVERRIDE = false; // only true for living social uk
export const SHOW_REVIEWS = true; // true for all
export const SHOW_TRAVEL_REVIEWS = true; // true for all
export const GIFTING_BUILDER = true; // false for LSUK and LSIE
export const MANUAL_NAVIGATION_ADDED = true; // true for 5pm
export const SHOW_GIFTBANNER_DEFAULT_BG = true; // true for 5pm and Wowcher
export const LIGHTPAGE_CWV = true; // true for Wowcher, LS and 5pm
export const VFIVE_AB = false; // true only for Wowcher
export const OPEN_IN_APP_VARIANT_TWO = true; // true for Wowcher and 5pm
export const GO_BACK_VARIANT_TWO = false; // true for LS and LS IE
